import { errorLine, loadErrorLine } from '../../api/errors';

/**
 * A failed write reads the same everywhere: the quiet source line, under the
 * control that failed. Codes with a behavior of their own are handled at their
 * call site, so anything reaching here is the defensive or the unexpected.
 *
 * `load` marks a failed read (a list or a page that did not arrive), which must
 * never say that a change was not saved.
 */
export function ErrorLine({ error, load = false }: { error: unknown; load?: boolean }) {
  return <div className="src">{load ? loadErrorLine(error) : errorLine(error)}</div>;
}
